// Generated by scripts/generate_static_demo_mocks.py from data/backups/api-export/
// (real API responses captured from a dev company-router). Do not edit by hand.
import type { components as CompanyRouterComponents } from "../openapi/company-router";

type RouterUser = CompanyRouterComponents["schemas"]["User"];

export const demoUsers: RouterUser[] = [
  {
    _updated_at: "2026-08-19T16:38:23.893762",
    company_id: 88,
    date_created: "2026-08-19T16:38:23.893762",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-1bf3-80cb-9baa-478c39a12dbf",
    last_login: null,
    last_name: "Procurement1",
    prompt: "",
    username: "Anonymized.Procurement1",
  },
  {
    _updated_at: "2026-08-19T16:38:39.714414",
    company_id: 88,
    date_created: "2026-08-19T16:38:39.714414",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-1cd6-83c9-ab07-e08b8561bf64",
    last_login: null,
    last_name: "Procurement2",
    prompt: "",
    username: "Anonymized.Procurement2",
  },
  {
    _updated_at: "2026-08-20T13:58:32.786574",
    company_id: 88,
    date_created: "2026-08-20T13:58:32.786574",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-1d99-822f-9bff-ac78a5590aeb",
    last_login: null,
    last_name: "Accounting",
    prompt: "",
    username: "Anonymized.Accounting",
  },
  {
    _updated_at: "2026-08-20T16:04:54.605896",
    company_id: 88,
    date_created: "2026-08-20T16:04:54.605896",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-1e94-882c-8bfb-5d334d7e9064",
    last_login: null,
    last_name: "HR1",
    prompt: "",
    username: "Anonymized.HR1",
  },
  {
    _updated_at: "2026-08-20T16:05:08.145545",
    company_id: 88,
    date_created: "2026-08-20T16:05:08.145545",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-1f4e-829f-b7d7-52750c4feb03",
    last_login: null,
    last_name: "HR2",
    prompt: "",
    username: "Anonymized.HR2",
  },
  {
    _updated_at: "2026-08-20T16:05:19.842719",
    company_id: 88,
    date_created: "2026-08-20T16:05:19.842719",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-2093-8d82-bc99-acca812f9bcd",
    last_login: null,
    last_name: "HR3",
    prompt: "",
    username: "Anonymized.HR3",
  },
  {
    _updated_at: "2026-08-20T16:49:16.959636",
    company_id: 88,
    date_created: "2026-08-20T16:49:16.959636",
    early_adopter: "releases",
    email: null,
    external_auth_issuer: null,
    external_auth_subject: null,
    first_name: "Anonymized",
    id: "00058000-21ed-818c-821e-d6750f172337",
    last_login: null,
    last_name: "CS",
    prompt: "",
    username: "Anonymized.CS",
  },
];

// The visitor's own identity in the static demo.
export const demoWhoami: RouterUser = demoUsers[0];
